module.exports = __webpack_public_path__ + "build/static/media/logo.4b921af1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.svg
// module id = 277
// module chunks = 6